<div class="container-fluid grey-bg reset-password form-wrapper  change-password">
    <div class="row">
        <div class="col-12">
            <div class="form-box">
                <div class="top-detail">
                    <a href="/" title="Back to Home"><img alt="world of sweets logo"
                            src="../../assets/images/bonds-logo-footer.svg" /></a>
                    <h1>Set Password</h1>
                    <p>Enter new password for your account</p>
                </div>

                <form [formGroup]="ResetForm" (ngSubmit)="resetPassword()" autocomplete="off"> 
                    <div class="form-group">
                        <label >New Password <sup>*</sup></label>
                        <input  [type]="fieldTextType ? 'text' : 'password'"  class="form-control password" formControlName="password" placeholder="New Password">
                        <div class="input-group-append">
                              <i
                                [ngClass]="{
                                  'fa-eye-slash': !fieldTextType,
                                  'fa-eye': fieldTextType
                                }"
                                (click)="toggleFieldTextType()"
                              ></i>
                          </div>
                        <div *ngIf="submitted && ResetForm.controls.password.errors" class="error">
                            <div *ngIf="ResetForm.controls.password.errors.required"><img src="assets/images/error.svg" /> Password is required</div>
                            <div *ngIf="ResetForm.controls.password.errors.minlength">
                                <img src="assets/images/error.svg" /> Password must be at least 6 characters</div>
                              <div *ngIf="ResetForm.controls.password.errors.maxlength">
                                <img src="assets/images/error.svg" /> Password length is not more then 15 characters</div>
                        </div>
                    </div>
                    <div class="form-group mb-0">
                        <label > Confirm Password <sup>*</sup></label>
                        <input [type]="fieldTextType1 ? 'text' : 'password'"  class="form-control password" formControlName="confirmpassword" placeholder="Confirm Password">
                        <div class="input-group-append">
                            <i
                              [ngClass]="{
                                'fa-eye-slash1': !fieldTextType1,
                                'fa-eye1': fieldTextType1
                              }"
                              (click)="toggleFieldTextType1()"
                            ></i>
                        </div>
                        <div *ngIf="submitted && ResetForm.controls.confirmpassword.errors" class="error">
                            <div *ngIf="ResetForm.controls.confirmpassword.errors.required"><img src="assets/images/error.svg" /> Confirm Password is required</div>
                            <div *ngIf="ResetForm.controls.confirmpassword.errors.minlength">
                                <img src="assets/images/error.svg" /> Password must be at least 6 characters</div>
                              <div *ngIf="ResetForm.controls.confirmpassword.errors.maxlength">
                                <img src="assets/images/error.svg" /> Password length is not more then 15 characters</div>
                        </div>
                        <div class="error media-error" *ngIf="submitted"> {{errMessage}} </div>
                    </div>
                    <button type="submit" class="btn primary-btn">Reset Password</button>
                </form>
            </div>
            <app-footer></app-footer>
        </div>
    </div>
</div>